import { render, staticRenderFns } from "./CardSelect.vue?vue&type=template&id=b595dbea&scoped=true"
import script from "./CardSelect.vue?vue&type=script&lang=js"
export * from "./CardSelect.vue?vue&type=script&lang=js"
import style0 from "./CardSelect.vue?vue&type=style&index=0&id=b595dbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b595dbea",
  null
  
)

export default component.exports